<template>
  <section>
    <div class="root">
      <h3 class="push-down-20">Success! Now What?</h3>
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6">
            <HowToRux />
          </div>
          <div class="col-12 col-sm-6">
            <ViewYourRux :serialNumber="serialNumber" />
          </div>
          <div class="col-12 col-sm-6">
            <UpgradeYourRux />
          </div>
          <div class="col-12 col-sm-6">
            <ReferAFriend />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HowToRux from './cards/HowToRux'
import ViewYourRux from './cards/ViewYourRux'
import UpgradeYourRux from './cards/UpgradeYourRux'
import ReferAFriend from './cards/ReferAFriend'
export default {
  name: 'PostRegistration',
  components: { HowToRux, ViewYourRux, UpgradeYourRux, ReferAFriend },
  data: function () {
    return {
      serialNumber: '',
    }
  },

  mounted() {
    this.serialNumber = this.$route.params.serialNumber
  },
}
</script>

<style lang='scss' scoped>
</style>